import { useChatsSidebar } from '@/hooks/useChatsSidebar';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useLeftSidebar } from '@/hooks/useLeftSidebar';
import { cn } from '@/utils/utils';
import { HomeIcon, MessagesSquareIcon, SearchIcon } from 'lucide-react';
import { useSearchMenu } from '../New/useSearchMenu';
import SidebarItem from './SidebarItem';

const SidebarLinks = () => {
  const [_, setOpen] = useSearchMenu();
  const { setShowLeftSidebar } = useLeftSidebar();
  const isMobile = useIsMobile();
  const { showChatsSidebar, setShowChatsSidebar } = useChatsSidebar();

  return (
    <div className="flex flex-col gap-0.5">
      <SidebarItem
        onClick={() => {
          if (isMobile) setShowLeftSidebar(false);
        }}
        icon={HomeIcon}
        href="/new"
      >
        Home
      </SidebarItem>
      <SidebarItem
        onClick={() => {
          if (isMobile) setShowLeftSidebar(false);
          setOpen(true);
        }}
        icon={SearchIcon}
      >
        Search
        {/* <span className="ml-auto bg-border1 rounded-sm py-0.5 px-1 text-xs tracking-widest text-textGray2">
          ⌘K
        </span> */}
      </SidebarItem>
      <div id="sidebar-chats-button">
        <SidebarItem
          onClick={() => {
            setShowChatsSidebar((prev) => !prev);
          }}
          icon={MessagesSquareIcon}
          className={cn(showChatsSidebar && 'bg-muted')}
        >
          Chats
        </SidebarItem>
      </div>
    </div>
  );
};

export default SidebarLinks;
